import { MILLISECONDS_PER_DAY } from './dates.js';
const addDays = (date, days) => new Date(date.getTime() + days * MILLISECONDS_PER_DAY);
const daysBetween = (from, to) => Math.round((to.getTime() - from.getTime()) / MILLISECONDS_PER_DAY);
/**
 * Dates the reminders for a freshly sent invoice. Used by enrolment on the API and by the
 * invoice form's preview, so both always agree. Only dates after `today` are created so a
 * late-sent invoice never fires at once. An invoice that is already overdue gets one
 * catch-up reminder tomorrow carrying the channels of the steps it missed.
 */
export function planInvoiceReminders({ dueAt, today, steps, repeat, }) {
    const sortedSteps = [...steps].sort((a, b) => a.daysRelativeToDue - b.daysRelativeToDue);
    const planned = [];
    const missedSteps = [];
    for (const step of sortedSteps) {
        const scheduledDate = addDays(dueAt, step.daysRelativeToDue);
        if (scheduledDate <= today) {
            missedSteps.push(step);
            continue;
        }
        planned.push({
            daysRelativeToDue: step.daysRelativeToDue,
            scheduledDate,
            emailClient: step.emailClient,
            alertStaff: step.alertStaff,
            isRepeat: false,
        });
    }
    const lastEmailDay = Math.max(...sortedSteps
        .filter((step) => step.emailClient)
        .map((step) => step.daysRelativeToDue), Number.NEGATIVE_INFINITY);
    if (repeat && Number.isFinite(lastEmailDay)) {
        for (let repeatIndex = 1; repeatIndex <= repeat.max; repeatIndex++) {
            const daysRelativeToDue = lastEmailDay + repeat.every * repeatIndex;
            const scheduledDate = addDays(dueAt, daysRelativeToDue);
            if (scheduledDate <= today)
                continue;
            planned.push({
                daysRelativeToDue,
                scheduledDate,
                emailClient: true,
                alertStaff: false,
                isRepeat: true,
            });
        }
    }
    const isOverdue = dueAt < today;
    const tomorrow = addDays(today, 1);
    const tomorrowAlreadyCovered = planned.some((reminder) => reminder.scheduledDate.getTime() === tomorrow.getTime());
    if (isOverdue && missedSteps.length > 0 && !tomorrowAlreadyCovered) {
        planned.push({
            daysRelativeToDue: daysBetween(dueAt, tomorrow),
            scheduledDate: tomorrow,
            emailClient: missedSteps.some((step) => step.emailClient),
            alertStaff: missedSteps.some((step) => step.alertStaff),
            isRepeat: false,
        });
    }
    return planned.sort((a, b) => a.scheduledDate.getTime() - b.scheduledDate.getTime());
}
//# sourceMappingURL=reminder-dates.js.map